// L'IDÉE TAPÉE SUR LE SITE, gardée jusqu'au chat de l'app créée.
//
// Décision du 2026-11-01 : sur www, « Build it » mène à la connexion Google, puis au choix d'un
// forfait. Le site envoie vers /new?idea=… ; NewApp la garde dans le stockage du navigateur (le
// détour par le forfait quitte /new), puis la passe au chat de l'app qu'il crée, qui démarre avec.
// Elle n'est jamais envoyée seule : construire coûte, et c'est l'opérateur qui appuie.

const KEY = "perimetr.pendingIdea";

/** Une adresse ne doit pas remplir le chat sans limite. */
export const IDEA_MAX = 4000;

type Store = { getItem(k: string): string | null; setItem(k: string, v: string): void; removeItem(k: string): void };

function clean(v: unknown): string | null {
  if (typeof v !== "string") return null;
  const t = v.trim().slice(0, IDEA_MAX);
  return t === "" ? null : t;
}

/** L'idée que porte l'adresse (`?idea=…`), ou null. */
export function ideaFromSearch(search: string): string | null {
  return clean(new URLSearchParams(search).get("idea"));
}

/** L'idée que NewApp a passée en naviguant, ou null. */
export function ideaFromState(state: unknown): string | null {
  return clean((state as { idea?: unknown } | null | undefined)?.idea);
}

/** Un stockage bloqué ne casse jamais l'écran : l'idée est alors perdue, pas la console. */
export function keepIdea(store: Pick<Store, "setItem">, idea: string): void {
  try { store.setItem(KEY, idea); } catch { /* stockage bloqué */ }
}

export function readIdea(store: Pick<Store, "getItem">): string | null {
  try { return clean(store.getItem(KEY)); } catch { return null; }
}

export function forgetIdea(store: Pick<Store, "removeItem">): void {
  try { store.removeItem(KEY); } catch { /* stockage bloqué */ }
}

/** Où mène « Build it » sur le site : la connexion de la console, puis /new avec l'idée. */
export function ideaSignInHref(consoleOrigin: string, idea: string): string {
  const t = clean(idea);
  const next = "/new" + (t ? "?idea=" + encodeURIComponent(t) : "");
  return `${consoleOrigin}/login?next=${encodeURIComponent(next)}`;
}
